/** URL builders for the supply-chain monitoring area, all scoped to a client. */
export const monitoringPaths = {
  base: '/supplychain/monitoring',

  overview: (clientId: number | string) => `/supplychain/monitoring/${clientId}`,

  supplier: (clientId: number | string, supplierId: number | string) =>
    `/supplychain/monitoring/${clientId}/supplier/${supplierId}`,

  event: (clientId: number | string, supplierId: number | string, eventId: number | string) =>
    `/supplychain/monitoring/${clientId}/supplier/${supplierId}/event/${eventId}`,

  riskAssessment: (
    clientId: number | string,
    supplierId: number | string,
    assessmentId: number | string
  ) => `/supplychain/monitoring/${clientId}/supplier/${supplierId}/risk-assessment/${assessmentId}`,
};
